import type { ReactNode } from 'react';
import ErrorOutline from '~icons/material-symbols/error-outline';

interface ErrorPageShellProps {
  title: ReactNode;
  message: ReactNode;
  button?: ReactNode;
}

export default function ErrorPageShell({
  title,
  message,
  button,
}: ErrorPageShellProps) {
  return (
    <main className="sec-light flex min-h-0 w-full flex-1 items-center justify-center overflow-x-hidden p-6">
      <div className="flex w-full max-w-[min(48rem,100%)] flex-col items-center gap-3 rounded-xl border border-zinc-200 bg-white p-5 text-center shadow-sm">
        <div className="rounded-full bg-primary/7 p-2 text-primary">
          <ErrorOutline className="size-5" />
        </div>
        <div className="space-y-1">
          <h2 className="font-semibold">{title}</h2>
          <p className="text-sm">{message}</p>
          {button ? <div className="mt-3">{button}</div> : null}
        </div>
      </div>
    </main>
  );
}
